import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "./types";
import { getPermissions, login, loginByToken, signUp, verifyEmail } from "./profile.thunks";
import { UserResponse as Profile } from "libs/apiClient/data-contracts";

interface ProfileState {
	authed: boolean;
	isVerifyEmail: null | boolean;
	memorization: boolean;
	profile: Omit<Profile, "id"> & { id: null | number; isActive: boolean; isVerified: boolean; admin: boolean };
	error: IError;
}

const initialState: ProfileState = {
	authed: false,
	isVerifyEmail: null,
	memorization: false,
	profile: {
		dismissalDate: null,
		email: "",
		employmentDate: null,
		firstName: "",
		id: null,
		isActive: false,
		isVerified: false,
		lastName: "",
		middleName: "",
		phone: "",
		tabNumber: "",
		token: localStorage.getItem("token") || "",
		position: "",
		admin: false,
	},
	error: {
		status: null,
		message: "",
	},
};

export const reduxToken = initialState.profile.token;

const profileSlice = createSlice({
	name: "profileSlice",
	initialState,
	reducers: {
		memoryProfile(state) {
			state.memorization = true;
		},
		logout(state) {
			// localStorage.removeItem("token");
			// localStorage.removeItem("memorization");
			localStorage.clear();
			state.authed = false;
			state.isVerifyEmail = null;
			state.profile = {
				dismissalDate: null,
				email: "",
				employmentDate: null,
				firstName: "",
				id: 0,
				isActive: false,
				isVerified: false,
				lastName: "",
				middleName: "",
				phone: "",
				tabNumber: "",
				token: "",
				position: "",
				admin: false,
			};
		},

		clearVerifyEmail(state) {
			state.isVerifyEmail = null;
		},

		ClearError(state, action: PayloadAction) {
			state.error = {
				status: null,
				message: "",
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(login.fulfilled, (state, action: PayloadAction<any>) => {
			state.authed = true;
			state.profile = action.payload.profile;
			state.memorization = action.payload.memorization;
			state.error = {
				status: null,
				message: "",
			};
		});
		builder.addCase(login.rejected, (state, action) => {
			state.error = action.payload as IError;
		});
		builder.addCase(loginByToken.fulfilled, (state, action) => {
			state.authed = true;
			state.profile = { ...state.profile, ...action.payload };
			state.memorization = true;
			state.error = {
				status: null,
				message: "",
			};
		});
		builder.addCase(signUp.fulfilled, (state, action) => {
			state.authed = true;
			state.profile = { ...state.profile, ...action.payload };
			state.memorization = true;
			state.error = {
				status: null,
				message: "",
			};
		});
		builder.addCase(signUp.rejected, (state, action) => {
			state.error = action.payload as IError;
		});
		builder.addCase(getPermissions.fulfilled, (state, action) => {
			state.profile.admin = action.payload;
		});
		builder.addCase(verifyEmail.fulfilled, (state, action) => {
			state.isVerifyEmail = action.payload;
		});
	},
});

export const { memoryProfile, logout, clearVerifyEmail, ClearError } = profileSlice.actions;
export default profileSlice.reducer;
